// コミュニティ画面の ERB からマウントするコンポーネントの registry。
// spec / stories は負パターンで除外し、registry / バンドルへの混入を防ぐ。
// admin 用は components/admin/mountable/registry.ts に分離（越境マウント・バンドル混入を防ぐ）。
export const communityComponents = import.meta.glob([
  '@/components/mountable/*.tsx',
  '!@/components/mountable/*.spec.tsx',
  '!@/components/mountable/*.stories.tsx',
]);
